var ctrlopt = ctrlopt,
  generic = generic || {},
  moment = moment || {};

(function ($) {
  var apptBook = Drupal.appointmentBooking;
  var settings = Drupal.settings.globals_variables || {};
  var oab_postcode_override = settings.oab_postcode_override || 0;
  var oab_phone_override = settings.oab_phone_override || 0;
  var oab_phone_split_hk = settings.oab_phone_split_hk || 0;
  var isDisablePrice = +$('#appointment-book-container').attr('data-disable-price');
  var oab_moment_js_locale = settings.oab_moment_js_locale || '';

  /* Concrete View */
  apptBook.ConfirmSection = function (container) {
    apptBook.ConfirmSection.superclass.constructor.call(this);
    this.id = 'confirmation';
    this.container = container;
    this.confContainer = container.find('.confirmation-container');
    this.lessons = this.confContainer.find('.your-lessons');
    this.location = this.confContainer.find('.location');
    this.dateTime = this.confContainer.find('.date-time');
    this.artistName = this.confContainer.find('.artist');
    this.minLabel = this.container.attr('data-minutes-label');
    this.separator = this.container.attr('data-lessons-separator');
    this.currency = this.container.attr('data-currency-symbol');
    this.months = this.container.attr('data-month-names').split(',');
    this.confirmation_date_format = this.container.attr('data-confirmation-date-format') || 'D MMM YYYY';
    this.confirmation_time_format = this.container.attr('data-confirmation-time-format') || 'HH:mm';
    var momentLocale = this.container.attr('data-moment-locale')
      ? this.container.attr('data-moment-locale')
      : generic.cookie('LOCALE')
      ? generic.cookie('LOCALE').substr(0, 2)
      : 'en';

    moment.locale(momentLocale);
    this.myappointmentbutton = this.container.find('a.view-appts-button');
    this.totalDuration = 0;
    this.isVirtual = 0;
  };

  ctrlopt.extend(apptBook.ConfirmSection, apptBook.AbstractSection);

  apptBook.ConfirmSection.prototype.onUpdate = function (data) {
    var me = this,
      aPgName = document.title + ' - Confirmation';

    if (data.sectionId === this.id) {
      this.confData = data.params;
      if (this.confData.counter.calendars[0].virtual === '1') {
        this.isVirtual = 1;
      }
      this.buildLessons(this.confData.services);
      if (this.isVirtual) {
        this.buildVirtualAppointmentLink(this.confData.virtual_meeting_link);
      } else {
        this.buildLocation(this.confData.counter);
      }
      this.buildDateTime(this.confData);
      this.buildArtistName(this.confData.calendar);
      if (this.isVirtual) {
        this.container.find('.virtual_oab_content').removeClass('hidden');
        $('.appt-book-page-header .physical_oab_content').addClass('hidden');
      } else {
        this.container.find('.physical_oab_content').removeClass('hidden');
        $('.appt-book-page-header .virtual_oab_content').addClass('hidden');
      }

      generic.jsonrpc.fetch({
        method: 'user.json',
        onSuccess: function (jsonRpcResponse) {
          me.userData = jsonRpcResponse.getValue();
          if (me.userData && !me.userData.signed_in) {
            me.myappointmentbutton.hide();
          }
        },
        onFailure: function (jsonRpcResponse) {
          me.userData = null;
        }
      });
    }
  };

  apptBook.ConfirmSection.prototype.buildLessons = function (data) {
    var OAB_price_no_decimal = Drupal.settings.globals_variables.OAB_price_no_decimal || 0;
    var OAB_price_override =
      Drupal.settings.globals_variables.OAB_override_price_format !== 'undefined'
        ? Drupal.settings.globals_variables.OAB_override_price_format
        : 0;
    var lName,
      lDetails,
      myData,
      myNode,
      myLName,
      myLTime,
      myLPrice,
      separator = ' / ';

    me = this;
    if (!site.client.isMobile) {
      this.servicesName = this.lessons.find('.services-name');
      this.durationsPrices = this.lessons.find('.duration-price');
      this.lessonsName = this.servicesName.find('.lesson-name').remove();
      this.lessonsDetails = this.durationsPrices.find('.lesson-details').remove();

      for (var i = 0, len = data.length; i < len; i += 1) {
        myData = data[i];
        myData.price = myData.price || 0;
        lName = this.lessonsName.clone();
        lDetails = this.lessonsDetails.clone();
        myLName = myData.name;
        myLTime = myData.total_duration;
        myLPrice = OAB_price_no_decimal ? parseInt(myData.price) : myData.price;
        me.totalDuration += parseInt(myLTime);
        if (isDisablePrice && !+myLPrice) {
          (myLPrice = ''), (separator = ''), (this.currency = '');
        }
        lName.html(myLName + ':');
        if (OAB_price_override) {
          lDetails.html(myLTime + ' ' + this.minLabel + separator + myLPrice + this.currency);
        } else if ($('html').attr('dir') === 'rtl') {
          lDetails.html(myLTime + this.minLabel + separator + this.currency + myLPrice);
        } else {
          lDetails.html(myLTime + ' ' + this.minLabel + separator + this.currency + myLPrice);
        }
        this.servicesName.append(lName);
        this.durationsPrices.append(lDetails);
      }
    } else {
      this.lesson = this.lessons.find('.lesson').remove();
      for (var i = 0, len = data.length; i < len; i += 1) {
        myData = data[i];
        myData.price = myData.price || 0;
        myNode = this.lesson.clone();
        lName = myNode.find('.lesson-name');
        lDetails = myNode.find('.lesson-details');
        myLName = myData.name;
        myLTime = myData.total_duration;
        myLPrice = OAB_price_no_decimal ? parseInt(myData.price) : myData.price;
        if (isDisablePrice && !+myLPrice) {
          (myLPrice = ''), (separator = ''), (this.currency = '');
        }
        me.totalDuration += parseInt(myLTime);

        lName.html(myLName);
        lDetails.html(
          OAB_price_override
            ? myLTime + ' ' + this.minLabel + separator + myLPrice + this.currency
            : myLTime + ' ' + this.minLabel + separator + this.currency + myLPrice
        );
        this.lessons.append(myNode);
      }
    }
  };
  apptBook.ConfirmSection.prototype.buildVirtualAppointmentLink = function (apptLink) {
    var virtualMeetingLink = apptLink,
      apptHyperlink = this.location.find('.virtual-appt-link');

    if (virtualMeetingLink) {
      apptHyperlink.attr('href', virtualMeetingLink).text(virtualMeetingLink);
    }
  };
  apptBook.ConfirmSection.prototype.buildLocation = function (data) {
    var tpStr = '',
      googleStr = '',
      name = data.name,
      addr1 = data.address1,
      addr2 = data.address2,
      town = data.town,
      county = data.county,
      postCode = oab_postcode_override ? data.postcode.replace(/(\d{3})(\d{4})/, '$1-$2') : data.postcode,
      phone = data.phone,
      email = data.email,
      nameNode = this.location.find('.location-name'),
      addrNode = this.location.find('.location-address'),
      addr2Node = this.location.find('.location-address2'),
      townPostNode = this.location.find('.location-town-postcode'),
      phoneNode = this.location.find('.location-phone'),
      getDir = this.location.find('.location-direction-links');

    if (name) {
      nameNode.html(name);
      googleStr += name;
    } else {
      nameNode.hide();
    }

    if (addr1) {
      addrNode.html(addr1);
      googleStr += '+' + addr1;
    } else {
      addrNode.hide();
    }

    if (addr2) {
      addr2Node.html(addr2);
      googleStr += '+' + addr2;
    } else {
      addr2Node.hide();
    }

    if (town) {
      tpStr += town;
      googleStr += '+' + town;
    }

    if (county) {
      tpStr += tpStr === '' ? county : ', ' + county;
      googleStr += '+' + county;
    }

    if (postCode) {
      tpStr += tpStr === '' ? postCode : ', ' + postCode;
      googleStr += '+' + postCode;
    }

    if (tpStr === '') {
      townPostNode.hide();
    } else {
      townPostNode.html(tpStr);
    }

    if (phone) {
      if (oab_phone_override) {
        phone = data.phone.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
      } else if (oab_phone_split_hk) {
        phone = data.phone.replace(/(852|853|86)([0-9]{4})([0-9]{4,}$)/, '+$1-$2-$3');
      }
      phoneNode.html(phone);
      if (typeof phoneNode.attr('href') !== 'undefined') {
        phoneNode.attr('href', 'tel:' + phone);
      }
    } else {
      phoneNode.hide();
    }

    getDir.attr('href', 'https://www.google.com/maps?daddr=' + encodeURIComponent(googleStr));
  };

  apptBook.ConfirmSection.prototype.buildDateTime = function (data) {
    var m,
      d,
      y,
      h1,
      h2,
      mi,
      hSuffix1,
      hSuffix2,
      apptDayStr,
      apptHrStr,
      apptStartDate = data.firstStartTime
        ? this.convertTimeString(data.firstStartTime)
        : this.convertTimeString(data.start_time),
      apptEndDate = new Date(apptStartDate.getTime()),
      dateNode = this.dateTime.find('.appt-date'),
      dateDay = dateNode.find('.appt-date-day'),
      dateHours = dateNode.find('.appt-date-hours'),
      calDateLink = this.dateTime.find('.date-time-links'),
      calLocation;

    me.calContainer = me.container.find('.appt-date-cal');
    me.addCalLink = me.calContainer.find('.add-cal-link');
    me.calLinksCont = me.calContainer.find('.cals-container');
    me.calLinks = me.calContainer.find('.date-time-link');

    if (me.calContainer.length) {
      var typeClass = this.isVirtual ? '.virtual' : '.physical',
        addCalDesc =
          me.calContainer.find('.add-cal-desc' + typeClass).html() ||
          "Your Makeup Appointment is booked! Please arrive ten minutes before your lesson. We're looking forward to seeing you in person.";
      var addCalLink = me.calContainer.find('.add-cal-link'),
        calLinks = me.calContainer.find('.date-time-link'),
        addCalTitle = me.calContainer.find('.add-cal-title').html() || 'MAC Appointment',
        addr1 = data.counter.address1 || '',
        addr2 = data.counter.address2 || '',
        town = data.counter.town || '',
        county = data.counter.county || '',
        postcode = data.counter.postcode || '',
        virtMeetingLink = data.virtual_meeting_link;

      if (this.isVirtual) {
        calLocation = site.client.isMobile ? encodeURIComponent(virtMeetingLink) : virtMeetingLink;
      } else {
        calLocation = addr1 + ', ' + town + ', ' + (county !== '' ? county + ' ' : '') + postcode;
      }
    }

    apptEndDate.setTime(apptEndDate.getTime() + parseInt(me.totalDuration) * 60000);

    // Override moment JS for only india/hindi to translate AM PM
    if (moment.locale() === oab_moment_js_locale && oab_moment_js_locale === 'hi') {
      moment.defineLocale(oab_moment_js_locale, {
        meridiem: function (hour) {
          if (hour < 4) {
            return 'रात';
          } else if (hour < 12) {
            return 'सुबह';
          } else if (hour < 17) {
            return 'दोपहर';
          } else if (hour < 20) {
            return 'शाम';
          } else {
            return 'रात';
          }
        }
      });
    }

    // Moment adds '.' after short month names for a lot of locales, remove it.
    apptDayStr = moment(apptStartDate).format(this.confirmation_date_format).toUpperCase().replace('.', '');
    apptHrStr =
      moment(apptStartDate).format(this.confirmation_time_format) +
      ' - ' +
      moment(apptEndDate).format(this.confirmation_time_format);
    dateDay.text(apptDayStr);
    dateHours.text(apptHrStr);

    if (me.calContainer.length) {
      me.myCalendar = createCalendar({
        data: {
          device_mobile: site.client.isMobile,
          title: addCalTitle, // Event title
          start: new Date(apptStartDate.getTime()), // Event start date
          duration: me.totalDuration, // Event duration (IN MINUTES)
          end: new Date(apptEndDate.getTime()), // You can also choose to set an end time.
          address: calLocation,
          description: addCalDesc
        }
      });

      me.calLinks.each(function () {
        var $this = $(this);
        var calID = $(this).attr('data-cal'),
          data = $.grep(me.myCalendar, function (el, i) {
            if (el.calId.toLowerCase() === calID) {
              return el.calHref;
            }
          });
        var dataUri = data[0].calHref;

        createDownloadLink($this, dataUri, calID, 'calendar.ics');
        $this.on('click', function () {
          me.calLinksCont.toggleClass('expanded');
        });

        function createDownloadLink(anchorSelector, dataUri, calID, fileName) {
          var dateUriIE = '';
          var blobObject = null;

          if (window.navigator.msSaveOrOpenBlob && calID !== 'google') {
            dateUriIE = dataUri.split(',')[1];
            dateUriIE = decodeURIComponent(dateUriIE);
            var fileData = [dateUriIE];

            blobObject = new Blob(fileData);
            $(anchorSelector).click(function (e) {
              e.preventDefault();
              window.navigator.msSaveOrOpenBlob(blobObject, fileName);
            });
          } else {
            $(anchorSelector).attr('href', dataUri);
          }
        }
      });

      me.addCalLink.on('click', function () {
        me.calLinksCont.toggleClass('expanded');
      });
    }
  };

  apptBook.ConfirmSection.prototype.buildArtistName = function (data) {
    var aName = data.public_name,
      aNameNode = this.artistName.find('.artist-name');

    aNameNode.html(aName);
  };

  apptBook.ConfirmSection.prototype.convertTimeString = function (tString) {
    var split, dateArray, timeArray, y, m, d, hr, min, sec;

    split = tString.split(' ');
    dateArray = split[0].split('-');
    timeArray = split[1].split(':');

    y = parseInt(dateArray[0], 10);
    m = parseInt(dateArray[1], 10) - 1;
    d = parseInt(dateArray[2], 10);
    hr = parseInt(timeArray[0], 10);
    min = parseInt(timeArray[1], 10);
    sec = parseInt(timeArray[2], 10);

    return new Date(y, m, d, hr, min, sec);
  };

  Drupal.behaviors.apptBookConfirm = {
    attach: function (context) {
      var view = new apptBook.ConfirmSection($('#confirmation'));

      view.setModel(apptBook.sectionModel).startObserving();
    }
  };
})(jQuery);
